import React, { useEffect, useState } from 'react'
import Rightcontainer from '../Components/Rightcontainer'
import Header from '../Components/Header'
import '../css/terms.css'
import axios from 'axios'
import { Interweave } from 'interweave'
import { apiRequest } from '../store/allApi'
const PrivacyPolicy = () => {
  const [data, setData] = useState()


  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {

    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // ++++++++++++++++++++++++++

  const getdata = async () => {

    try {
      const res = await apiRequest('api/term/condition/About-Us', "GET", null)
      setData(res.data[0].Desc)
    } catch (e) {

    }
  }
  useEffect(() => {
    getdata()
  }, [])
  return (
    <div>
      <div className='leftContainer mb_space'>
        <Header />
        <div className='mt-5 py-4 px-3'>
          <div className='m-3'>
            <h1 className='profile_headings text-dark'>Privacy Policy</h1>

            {/* <h4>Introduction</h4> */}
            <>
              <p className='other_page_small_headings'>Introduction</p>
              <p className='p2 small_para'>
                These Terms and Conditions of Use ("Terms"), together with our Privacy Policy ("Privacy Policy"), constitute a legally binding agreement ("Agreement") between You ("User" or "Player") and SKILLSONOMY INFO PRIVATE LIMITED("SKILLSONOMY", "We", "Us", or "Our").

                By accessing, registering, or using our Platform, you agree to be bound by these Terms and our Privacy Policy. If you do not agree with these Terms, please do not use the Platform.
              </p>
              <p className='p1 other_page_small_headings'>
                User Eligibility & Approval:
              </p>
              <p className='p2 small_para mb-2'>
                2.1 Acceptance
                You agree to this Agreement by:

                Reading and understanding these Terms and the Privacy Policy;

                Reviewing all applicable game rules and conditions.

              </p>
              <p className='p2 small_para'>
                2.2 Eligibility Criteria
                You may only use the SKILLSONOMY Platform if:

                You are at least 18 years of age and legally capable of entering into a binding agreement;

                You are not a resident of the following states in India: Andhra Pradesh, Assam, Nagaland, Odisha, Sikkim, Tamil Nadu, Telangana;

                You are not legally barred from accessing or using games of skill under applicable law;

                If representing a legal entity, you have appropriate authority to act on its behalf.
              </p>



              <p className='p1 other_page_small_headings'>
                Nature of Games on SKILLSONOMY:
              </p>
              <p className='p3 small_para'>
                3.1 Game Classification
                SKILLSONOMY hosts skill-based games in accordance with Section 12 of the Public Gambling Act, 1867, which excludes games of skill from gambling prohibitions.

                A game of skill is one where success predominantly depends on a player's knowledge, training, strategy, experience, and decision-making.
              </p>

              <p className='p3 small_para'>
                3.2 Game Features
                Games like Ludo, Chess, Puzzle Challenges, and others available on SKILLSONOMY are primarily skill-based.

                Some elements of chance may exist but are outweighed by skill.

                Players' improvement is expected with consistent play and learning.
              </p>

              <p className='p3 small_para'>

                3.3 Regional Restrictions
                Residents of Tamil Nadu, Andhra Pradesh, Telangana, Assam, Odisha, Sikkim, Nagaland, and individuals located outside India are strictly prohibited from accessing or participating in games on the platform.
              </p>



              <p className='p1 other_page_small_headings'>
                Game Rules & Fair Play:
              </p>

              <p className='p3 small_para'>
                4.1 Recording Requirement
                All players must record gameplay as a measure against cheating or errors.

              </p>
              <p className='p3 small_para'>
                4.2 Dispute Handling
                If the game fails to start or no moves were made, submit the recording to support for cancellation.

                Without valid proof (like gameplay video), the game will be marked as lost.

                If your pawn is not moved or opened, the game may be considered void.

                If your opponent exits the match intentionally early and lacks proof for cancellation, you may be declared the winner.
              </p>


              <p className='p3 small_para'>
                4.3 Anti-Cheating Policy
                Strict action, including account suspension, will be taken against any cheating, automation (bot use), or manipulation.

                Any player suspected of hacking, collusion, or use of unauthorized third-party tools will face a permanent ban.

              </p>


              <p className='p1 other_page_small_headings'>
                Deposits & Withdrawals:
              </p>
              <p className='p3 small_para'>
                5.1 Deposits
                Users can deposit balance via the “Buy Chips” section.

                Suspicious transactions may result in temporary account blocking. Contact support with verification details to restore access.
              </p>
              <p className='p3 small_para' >
                5.2 Withdrawals
                Withdrawals can be made by placing a Sell Request within the app.

                Withdrawals are generally processed by the support team within 1 to 5 business days.

                No query will be entertained after a withdrawal is completed.

                Incorrect payment details will not be eligible for refunds.
              </p>



              <p className='p1 other_page_small_headings'>
                Commissions and Charges:
              </p>
              <p className='p3 small_para'>
                SKILLSONOMY charges a flat 10% commission on all challenge amounts, after adjusting any applicable referral rewards or bonuses.

                Any government taxes applicable (e.g., TDS/GST) may be deducted as per legal requirements.
              </p>

              <p className='p1 other_page_small_headings'>
                Use of Personal Information:
              </p>
              <p className='p3 small_para'>
                SKILLSONOMY may use your information to:

                Provide support and respond to inquiries;

                Send essential service updates;

                Offer marketing communications (with your consent) via SMS, Email, WhatsApp, or Voice Call;

                Comply with legal obligations or regulatory requests.

                For more, refer to our full Privacy Policy.
              </p>

              <p className='p1 other_page_small_headings'>
                User Conduct and Responsibilities:
              </p>

              <p className='p3 small_para'>
                By using SKILLSONOMY, you agree to:

                Maintain the confidentiality of your account credentials;

                Use the Platform only for lawful and permitted activities;

                Not impersonate others or create multiple accounts to exploit promotions;

                Respect fair play guidelines and competition integrity.
              </p>

              <p className='p1 other_page_small_headings'>
                Account Suspension & Termination:
              </p>

              <p className='p3 small_para'>
                SKILLSONOMY reserves the right to suspend or permanently terminate accounts in cases of:

                Fraud or misuse of the platform;

                Breach of these Terms;

                Legal non-compliance or regulatory direction;

                Repeated user complaints or unethical behavior..
              </p>

              <p className='p1 other_page_small_headings'>
                Limitation of Liability:
              </p>

              <p className='p2 small_para'>
                SKILLSONOMY is not responsible for:

                Technical issues or connectivity failures on the user's side;

                Loss of data due to negligence in device storage;

                Incorrect withdrawals caused by inaccurate bank details entered by the user.


              </p>

              <p className='p1 other_page_small_headings'>
                Governing Law & Jurisdiction:
              </p>


              <p className='p2 small_para'>
                This Agreement shall be governed by and construed in accordance with the laws of India. Any disputes arising shall be subject to the exclusive jurisdiction of the courts of Delhi, India.
              </p>
              <p className='p1 other_page_small_headings'>
                Updates to Terms
              </p>
              <p className='p2 small_para'>
                We may update these Terms from time to time to reflect changes in our services or legal obligations. Continued use of the platform after updates constitutes your acceptance of the revised Terms.
              </p>

              <p className='p1 other_page_small_headings'>
                For any queries or support:
              </p>
              <p className='p2 small_para'>
                📧 Email:support@skillsonomy.com<br />
                🌐 Website:www.skillsonomy.com<br />
                📞 WhatsApp/Call Support available in-app<br />
                <br />
                <strong>Registration Number:</strong> 08ABPCS1411C1ZM<br />
              </p>
            </>
          </div>
        </div>
      </div>
      <div className='rightContainer'>
        <Rightcontainer />
      </div>
    </div>
  )
}
export default PrivacyPolicy
